// @ts-expect-error @todo refactor: moved from old file
export const FactoryComment = ({ createdAt, ...props }) => ({
  id: null,
  owner: null,
  author: 'John Doe',
  commentable: null,
  content: '',
  createdAt: createdAt || Date.now(),
  ...props,
})
